<template>
	<div class="lowprice-wrap" v-loading="loading">
		<div class="input-wraper">
			<span>违规获取时间:</span>&nbsp;
			<el-date-picker
			v-model="lowpriceDate"
			value-format="yyyy-MM-dd"
			size="small"
			type="daterange"
			range-separator="~"
			@change="queryData"
			:picker-options="pickerOptions"
			start-placeholder="请选择"
			end-placeholder="请选择"
			></el-date-picker>
		</div>
		<el-timeline >
			<el-timeline-item  :timestamp="item.synchrotime" placement="top" v-for="(item ,i) in lowPriceRecordList" :key="i">
				<div style="background-color: white;padding: 20px;border-radius: 16px;overflow: hidden;">
					<div style="height: 110px;border-bottom: 1px dashed #ccc;padding-bottom: 8px;">
						<el-image class="img" :src="item.logopicurl" style="margin-right: 10px;width: 80px;height: 80px;float: left;"></el-image>
						<div style="height: 80px;float: left;width: 625px;">
							<!-- 标题 -->
							<div>
								<el-link type="primary" target="_blank" :href="item.itemlink" :underline="false" class="elElLipsis"
									style="
									text-overflow: -o-ellipsis-lastline;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 1;
									-webkit-box-orient: vertical;
									width: 100%;">
								{{item.itemtitle}}</el-link>
							</div>
							<!-- SKU信息 -->
							<div style="margin: 8px 0 8px 0;">
								{{item.skuname}}
							</div>
							<!-- 产品信息 -->
							<div>
								<div style="margin: 8px 0 8px 0;">
									{{item.productname}}
								</div>
							</div>
							<div>
								<div v-if="item.price" style="float: left;margin-right: 8px;font-size: 12px;">
									标价：¥ {{item.price}}
								</div>
								<div v-if="item.islowprice == '是'" style="float: right;margin-right: 8px;font-size: 12px;" class="lowStyle">
									标低
								</div>
								<div v-if="item.checkprice" style="float: left;margin-right: 8px;font-size: 12px;">
									标价限价：¥ {{item.checkprice}}
								</div>
								<div v-if="item.availablecheckprice" style="float: left;margin-right: 8px;font-size: 12px;">
	                到手价：¥ {{item.availablecheckprice}}
	              </div>
								<div v-if="item.availablecheckprice" style="float: left;margin-right: 8px;font-size: 12px;">
	                到手价限价：¥ {{item.availablecheckprice}}
	              </div>
	              <div class="lowStyle" v-if="item.availableislowprice == '是'" style="float: right;margin-right: 8px;font-size: 12px;" >
	                到手低
								</div>
	            </div>
						</div>
					</div>
					<!-- 优惠券 -->
					<div v-if="item.coupons && item.coupons != ''">
						<div v-for="(n,index) in item.coupons.split(',')" :key="index" class="discount" style="float: left;margin: 8px 8px 8px 0;">
							<div class="storeCoupon" v-if="n.indexOf('满N件折') != -1">
								{{n}}
							</div>
							<div class="ticketCoupon" v-if="n.indexOf('店铺促销') != -1">
								{{n}}
							</div>
							<div class="redPro" v-if="n.indexOf('满额减') != -1 || n.indexOf('店铺活动') != -1">
								{{n}}
							</div>
							<div class="goodsCoupon" v-if="n.indexOf('领券') != -1">
								{{n}}
							</div>
							<div class="ticketCoupon" v-if="n.indexOf('淘客') != -1">
								{{n}}
							</div>
							<div class="goodsCoupon" v-if="n.indexOf('优惠券') != -1">
								{{n}}
							</div>
							<div class="redPro" v-if="n.indexOf('活动') != -1">
								{{n}}
							</div>
							<div class="storeCoupon" v-if="n.indexOf('跨店满减') != -1">
								{{n}}
							</div>
							<div class="sellPurple" v-if="n.indexOf('预售') != -1">
								{{n}}
							</div>
							<div class="categoryShoppingCoupon" v-if="n.indexOf('品类购物券') != -1">
								{{n}}
							</div>
							<div class="grayShop"  v-if="n.indexOf('自定义') != -1 || n.indexOf('关注店铺券') != -1">
								{{n}}
							</div>
						</div>
					</div>
				</div>
			</el-timeline-item>
		</el-timeline>
		<el-button size="small" class="btnMore" style="margin-bottom: 50px;" v-if="isMoreBtn && lowPriceRecordList.length>0" @click="loadMore">加载更多...</el-button>
		<div class="nodata" v-if="lowPriceRecordList.length == 0"><img src="@/assets/img/other/nodata.svg">暂无数据</div>
	</div>
</template>
<script>
import {getRecentOneMonth} from '@/libs/date'
import {fetchGet, fetchPost} from "@/libs/reqCommon";
export default {
	props:{
		lowpriceData:{
			type:Object,
			default:() => {}
		}
	},
	name:'lowPriceRecord',
	data(){
		return {
			pickerOptions: {
				shortcuts: [
					{
						text: '今日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
							picker.$emit('pick', [start, start]);
						}
					},{
						text: '近7日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
							picker.$emit('pick', [start, end]);
						}
					},{
						text: '近15日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
							picker.$emit('pick', [start, end]);
						}
					},{
						text: '近30日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
							picker.$emit('pick', [start, end]);
						}
					},{
						text: "近90日",
						onClick: picker => {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '近365日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
							picker.$emit('pick', [start, end]);
						}
					}
				]
			},
			loading:false,
			lowpriceDate:[],
			lowPriceRecordList:[],
			isMoreBtn:false,
			query: {
				pageNo:1,
				pageSize:10
			},
			couponList:[{
				accessType: "2",
				couponsType: "1",
				fullPrice: 158,
				reductionPrice: 10
			}]
		}
	},
	created() {
		this.getRencentDate();
		this.getLowPriceData();
	},
	methods:{
		couponType(value) {
			let itemType = {
				color: 'green',
				type: '自定义'
			};
			let couponType = Number(value.couponsType);

			if (couponType === 1) {
				return (itemType = {
					color: 'orange',
					type: '店铺'
				});
			} else if (couponType === 2) {
				return (itemType = {
					color: 'orangered',
					type: '活动'
				});
			} else if (couponType === 3) {
				itemType = {
					color: 'purple',
					type: '预售'
				};
			}
			return itemType;
		},
		getRencentDate(){
			let res = getRecentOneMonth();
			this.lowpriceDate[0] = '';
			this.lowpriceDate[1] = '';
		},
		// 根据时间查询
    queryData(date){
			console.log(1231231)
			console.log(date)
      let query = {
        ...this.query,
        begintime:date[0],
        endtime:date[1],
        shopname:this.lowpriceData.shopName || this.lowpriceData.shop_name,
				platform:this.lowpriceData.platformCode,
				wangwang:this.lowpriceData.wangwang,
      }
      let url = "hcm/iprViolationRetrieveData/shopLowPriceList"
      this.lowPriceRecordData(url,query);
		},
		// 违规记录数据请求
     lowPriceRecordData(url,query){
			 this.loading = true;
			 fetchGet(url,query).then(res =>{
			   if(res.status == "10000"){
				   for(let i = 0;i<res.data.length;i++){
						 if (res.data[i].productPrice) {
							 let productPrice = res.data[i].productPrice;
							 res.data[i].productPrice = JSON.parse(productPrice)
						 }
					 }
					 if (res.data.length<this.query.pageSize)
           this.isMoreBtn = false;
           else this.isMoreBtn = true;
           this.lowPriceRecordList = res.data;
         }
         this.loading = false;
      });
		},
		getLowPriceData(){
			let url = "/hcm/iprViolationRetrieveData/shopLowPriceList"
			let query = {
				pageNo: 1,
				pageSize: this.query.pageSize,
				startTime:this.lowpriceDate[0],
				endTime:this.lowpriceDate[1],
        shopname:this.lowpriceData.shopName || this.lowpriceData.shop_name,
				platform:this.lowpriceData.platform_code || this.lowpriceData.platformCode,
				wangwang:this.lowpriceData.wangwang,
			}
			this.lowPriceRecordData(url,query);
		},
		loadMore(){
			this.query.pageSize = this.query.pageSize + 10;
            this.getLowPriceData();
		}
	}
}
</script>
<style lang="scss">
.lowprice-wrap {
	.elElLipsis {

	}
	.lowStyle {
		border-color: rgba(255, 163, 158, 1);
		display:inline-block;
		display:inline;
		zoom:1;
		border: 1px solid rgba(255, 163, 158, 1);
		border-radius: 5px;
		color: #F5222D;
		background-color: rgba(254, 240, 239, 1);
		padding: 0px 3px;
	}
	.item {
		.redPro {
		  height: 25px;
		  line-height: 25px;
		  display:inline-block;
		  display:inline;
		  zoom:1;
		  border: 1px solid rgba(135, 232, 222, 1);
		  border-radius: 5px;
		  color: #13C2C2;
		  background-color: rgba(230, 255, 251, 1);
		  padding: 0px 5px;
		}

		.sellPurple {
		  height: 25px;
		  line-height: 25px;
		  display:inline-block;
		  display:inline;
		  zoom:1;
		  border: 1px solid #7644fb;
		  border-radius: 5px;
		  color: #7644fb;
		  padding: 0px 5px;
		}

		.grayShop {
		  height: 25px;
		  line-height: 25px;
		  display:inline-block;
		  display:inline;
		  zoom:1;
		  border: 1px solid rgba(217, 217, 217, 1);
		  border-radius: 5px;
		  color: rgba(0, 0, 0, 0.647058823529412);
		  background-color: rgba(245, 245, 245, 1);
		  padding: 0px 5px;
		}

		.storeCoupon {
		  height: 25px;
		  line-height: 25px;
		  display:inline-block;
		  display:inline;
		  zoom:1;
		  border: 1px solid rgba(255, 173, 210, 1);
		  border-radius: 5px;
		  color: #F5317F;
		  background-color: rgba(255, 240, 246, 1);
		  padding: 0px 5px;
		}

		.goodsCoupon {
		  height: 25px;
		  line-height: 25px;
		  display:inline-block;
		  display:inline;
		  zoom:1;
		  border: 1px solid rgba(255, 163, 158, 1);
		  border-radius: 5px;
		  color: #F5222D;
		  background-color: rgba(254, 240, 239, 1);
		  padding: 0px 5px;
		}

		.categoryShoppingCoupon {
		  height: 25px;
		  line-height: 25px;
		  display:inline-block;
		  display:inline;
		  zoom:1;
		  border: 1px solid rgba(255, 187, 150, 1);
		  border-radius: 5px;
		  color: #FA541C;
		  background-color: rgba(255, 242, 232, 1);
		  padding: 0px 5px;
		}

		.ticketCoupon {
		  height: 25px;
		  line-height: 25px;
		  display:inline-block;
		  display:inline;
		  zoom:1;
		  border: 1px solid rgba(183, 235, 143, 1);
		  border-radius: 5px;
		  color: #52C41A;
		  background-color: rgba(246, 255, 237, 1);
		  padding: 0px 5px;
		}

		.cutAcross {
		  height: 25px;
		  line-height: 25px;
		  display:inline-block;
		  display:inline;
		  zoom:1;
		  border: 1px solid rgba(145, 213, 255, 1);
		  border-radius: 5px;
		  color: #1890FF;
		  background-color: rgba(230, 247, 255, 1);
		  padding: 0px 5px;
		}
		.discount {
	    text-align: center;
	    font-size: 12px;
	    color: white;
	    margin-bottom: 7px;
	    line-height: 20px;
	    float: left;
	  }
		.priceTag {
			background-color: rgba(230, 247, 255, 1);
			border-color: rgba(145, 213, 255, 1);
			color: #1890FF;
			width: 29px;
			height: 20px;
			line-height: 20px;
			font-size: 12px;
			text-align: center;
			float: left;
		}

		.theirPriceTag {
			background-color: rgba(254, 240, 239, 1);
			border-color: rgba(255, 163, 158, 1);
			color: #F5222D;
			width: 65px;
			height: 20px;
			line-height: 20px;
			font-size: 12px;
			text-align: center;
			float: left;
		}
		.tit {
			vertical-align: top;
			display: inline-block;
			width: 60px;
		}
		.con {
			display: inline-block;
			padding-left: 10px;
			.img {
				width: 70px;
				height: 70px
			}
			.text-wrap {
				display: inline-block;
				vertical-align: top;
				padding: 0 0 0 10px;
			}
			.el-link {
				width: 100% !important;
			}
			&.price span{
				padding: 0 40px 0 0;
			}
		}
	}
	.tag {
		display: inline-block;
		margin-top: 4px;
		margin-left: 2px;
		background: #67c23a;
		color: #fff;
		padding: 0 4px;
		height: 18px;
		border-radius: 2px;
		font-size: 12px;
		line-height: 18px;
		text-align: center;

		.type {
			padding-right: 4px;
			padding-left: 0;
		}

		&.orange {
			border: 1px solid #ffb938;
			background: #ffb938;
		}

		&.orangered {
			border: 1px solid #f40;
			background: #f40;
		}

		&.green {
			border: 1px solid #67c23a;
			background: #67c23a;
		}

		&.purple {
			border: 1px solid #a43ca4;
			color: #a43ca4;
		}
	}
}
</style>
